export default __webpack_public_path__ + "5eb544bc693e50600695f0d501cffcb1.svg";